module.exports = __webpack_public_path__ + "static/karkasdom-d9cde74dc31e55c923467aef112925b2.jpg";